// Module
var code = "<div class=\"logo\"></div>\n";
// Exports
export default code;